import { motorRatesData } from "./motor.js";
import { piRatesData } from "./pi.js";
import { individualMedicalRatesData } from "./individualMedical.js";
import { groupMedicalRatesData } from "./groupMedical.js";
export const motorRates = motorRatesData;
export const piRates = piRatesData;
export const individualMedicalRates = individualMedicalRatesData;
export const groupMedicalRates = groupMedicalRatesData;
export const allRates = {
    motor_private: motorRates,
    pi: piRates,
    individual_medical: individualMedicalRates,
    group_medical: groupMedicalRates,
};
